/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlFileRisk1 = {
    Benign: 'BENIGN',
    Malware: 'MALWARE',
    LateStage: 'LATE_STAGE',
    Nuisance: 'NUISANCE',
    LiveOffTheLand: 'LIVE_OFF_THE_LAND',
    RemoteManagement: 'REMOTE_MANAGEMENT',
    Unknown: 'UNKNOWN'
} as const;
export type ControlFileRisk1 = typeof ControlFileRisk1[keyof typeof ControlFileRisk1];


export function ControlFileRisk1FromJSON(json: any): ControlFileRisk1 {
    return ControlFileRisk1FromJSONTyped(json, false);
}

export function ControlFileRisk1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlFileRisk1 {
    return json as ControlFileRisk1;
}

export function ControlFileRisk1ToJSON(value?: ControlFileRisk1 | null): any {
    return value as any;
}

